export default (index, item) => item.id;
